import React from "react";
import CrudManager from "./CrudManager";

export default function EventsManager() {
    return (
        <CrudManager
            testId="admin-events"
            resource="/admin/events"
            title="Eventos"
            idField="id"
            columns={[
                { key: "event_date", label: "Fecha" },
                { key: "title", label: "Título" },
                { key: "location", label: "Lugar" },
                { key: "published", label: "Publicado" },
            ]}
            fields={[
                { name: "title", label: "Título", required: true },
                { name: "description", label: "Descripción", type: "textarea", rows: 4, required: true },
                { name: "event_date", label: "Fecha (AAAA-MM-DD)", type: "date", required: true, placeholder: "2026-03-15" },
                { name: "event_time", label: "Hora (HH:MM)", placeholder: "18:00" },
                { name: "location", label: "Lugar" },
                { name: "image", label: "URL imagen" },
                { name: "cta_label", label: "Texto botón CTA", placeholder: "Confirmar asistencia" },
                { name: "cta_url", label: "URL botón CTA", placeholder: "mailto:info@asatta.org" },
                { name: "published", label: "Estado", type: "checkbox", placeholder: "Publicado" },
            ]}
            defaultValues={{
                title: "",
                description: "",
                event_date: "",
                event_time: "",
                location: "Tarifa",
                image: "",
                cta_label: "",
                cta_url: "",
                published: true,
            }}
        />
    );
}
